module.exports = __webpack_public_path__ + "img/icon_memos.a2ae24a9.svg";